"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFirstVisibleElementFromSelector = void 0;
var focus_1 = require("../focus");
var getDocument_1 = require("./getDocument");
/**
 * Gets the first visible element that matches the given selector
 * @param selector - The selector to use to find potential visible elements
 * @returns The first visible element that matches the selector, otherwise undefined
 *
 * @public
 */
function getFirstVisibleElementFromSelector(selector) {
    var elements = getDocument_1.getDocument().querySelectorAll(selector);
    // Iterate across the elements that match the selector and return the first visible/non-hidden element
    return Array.from(elements).find(function (element) { return focus_1.isElementVisibleAndNotHidden(element); });
}
exports.getFirstVisibleElementFromSelector = getFirstVisibleElementFromSelector;
//# sourceMappingURL=getFirstVisibleElementFromSelector.js.map